import { useFormContext } from 'react-hook-form';
import { FormContainer } from 'components/layout';
import { Box } from '@mui/material';
import { SelectApplications } from 'components/common';
import { AdAccountSelect } from './TikTokFormComponents';
import { memo, useCallback } from 'react';

const AppAccount = memo(() => {
  const { setValue } = useFormContext();

  const handleChangeApp = useCallback(() => {
    setValue('selectedCampaigns', []);
    setValue('selectedCreatives', []);
    setValue('accountId', '', { shouldValidate: true });
  }, [setValue]);

  const handleChangeAccId = useCallback(() => {
    setValue('selectedCampaigns', []);
    setValue('selectedCreatives', []);
  }, [setValue]);

  return (
    <FormContainer title={'Choose App and Ad Type'}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'start', width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
          <Box sx={{ display: 'flex', flex: 1 }}>
            <SelectApplications
              name={'app'}
              handleChange={handleChangeApp} />
          </Box>
          <Box sx={{ display: 'flex', flex: 1 }}>
            <AdAccountSelect handleChange={handleChangeAccId} />
          </Box>
        </Box>
      </Box>
    </FormContainer>
  );
});

AppAccount.displayName = 'AppAccount';

export default AppAccount;